"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DropListItem = void 0;
var React = require("react");
var Icons_1 = require("../../Icons");
var DropList_styles_1 = require("./DropList.styles");
exports.DropListItem = React.forwardRef(function (_a, ref) {
    var Title = _a.Title, Important = _a.Important, Disabled = _a.Disabled, OnClick = _a.OnClick, ItemIcon = _a.ItemIcon, children = _a.children, Selected = _a.Selected, StayOpenAfterClick = _a.StayOpenAfterClick;
    var handleOnClicked = function (e) {
        e.nativeEvent.stopImmediatePropagation();
        if (Boolean(StayOpenAfterClick)) {
            e.stopPropagation();
        }
        if (!Disabled) {
            OnClick();
        }
    };
    return (React.createElement(DropList_styles_1.MenuRow, { role: "none" },
        React.createElement(DropList_styles_1.ItemButton, { "aria-selected": Selected, className: Important ? "important" : "", disabled: Disabled, onClick: handleOnClicked, role: "menuitem", Selected: Selected, tabIndex: !Disabled ? -1 : -2, title: Title, ref: ref },
            ItemIcon && (React.createElement(DropList_styles_1.IconBlock, null,
                React.createElement(Icons_1.Icon, { Icon: ItemIcon, Height: "24px", Width: "24px" }))),
            React.createElement(DropList_styles_1.Caption, null, children))));
});
